(function () {
    'use strict';

    angular.module('GorillaBoy.directives')
        .directive('showMoreLess', ['$rootScope', function ($rootScop) {
            return {
                restrict: 'A',
                transclude: true,
                template: '<div ng-transclude class="showMoreLess-content-container" ng-class="{\'expanded\': expanded}"></div>' + 
                        '<div class="showMoreLess-bar">' + 
                            '<span class="wd-blue-link clickable" ng-click="toggleHeight($event)"><translate>{{ expanded ? \'SHOW_MORE_LESS_LABEL_SHOW_LESS\' : \'SHOW_MORE_LESS_LABEL_SHOW_MORE\' }}</translate></span>' + 
                        '</div >',
                link: function ($scope, $element, $attrs) {
                    $scope.expanded = false;
                    $scope.toggleHeight = function (event) {
                        $scope.expanded = !$scope.expanded;
                    };
                }
            };
        }]);
}());